import { AfterViewChecked, Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Centre } from '../../models/centre.model';
import { CentreService } from '../../services/centre.service';

import { ProduitService } from '../../services/produit.service';
import { ProduitForfaitInfo, Forfait, CoursForfait } from '../../models/produit.model';
import { Prof } from '../../models/personne.model';

import { environment } from '../../../environments/environment';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { OffreEmploi } from '../../models/offreEmploi.model';
import { OffreEmploiService } from '../../services/offreEmploi.service';
import { PaveService } from '../../services/pave.service';
import { Pave } from '../../models/pave.model';

@Component({
  selector: 'produit-forfait',
  templateUrl: './produitForfait.component.html',
  styleUrls: ['./produitForfait.component.scss']
})
export class ProduitForfaitComponent implements OnInit, AfterViewChecked {
    environment = environment;

    nombre_de_centres = 0;

    offres_emploi: OffreEmploi[];
    paves: Pave[];

    centres: Centre[];
    forfait: Forfait;
    prof: Prof;
    course_column_1: CoursForfait[] = new Array<CoursForfait>();
    course_column_2: CoursForfait[] = new Array<CoursForfait>();

    @Input() id_instance: number;
    titre_modifie: string;
    @Input() produit_forfait_info: ProduitForfaitInfo;
    titre_produit_readable: string;

    isLoadingCenter = true;
    isLoadingPrepaInfo = true;
    isLoadingForfait = true;
    isLoadingProf = true;
    isLoadingOffres = true;

    nombre_de_places_restantes: number;

    url_instance: string;

    constructor(
        private centreService: CentreService,
        private produitService: ProduitService,
        private offreEmploiService: OffreEmploiService,
        private paveService: PaveService,
        private route: ActivatedRoute,
        private router: Router,
        private titleService: Title,
        private metaTagService: Meta,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.route.params.subscribe( params => {
            this.id_instance = params.id_instance;
            this.titre_modifie = params.titre_modifie;
            this.url_instance = params.url_instance;
        } );
    }

    ngOnInit() {
        this.getPrepa(this.id_instance);

        this.nombre_de_places_restantes = (this.id_instance % 3) + 3;
    }

    setTags() {
        let ville = '';
        if (this.centres && this.centres.length > 0 && this.centres[0].ville !== '') {
            ville = ' à ' + this.centres[0].ville;
        }
        this.titleService.setTitle(this.produit_forfait_info.titre_produit + ville);
        this.metaTagService.updateTag({
          name: 'description',
          content: this.produit_forfait_info.titre_produit + ' - ' + this.produit_forfait_info.nom_instance
        });
    }

    ngAfterViewChecked() {
        if (!this.isLoadingPrepaInfo) {
            this.setBandeau();
        }
        if (!this.isLoadingForfait) {
            this.initColors();
        }
    }

    handlePrepaInfoRecover() {
        if (this.produit_forfait_info.titre_produit) {
            this.titre_produit_readable = this.produit_forfait_info.titre_produit.split('<br>').join('');
        }
        if (this.produit_forfait_info.centres && this.produit_forfait_info.centres.length > 0 &&
            !!this.produit_forfait_info.centres.join()) {
            this.getCentresByIds(this.produit_forfait_info.centres);
        } else {
            this.isLoadingCenter = false;
        }
        if (this.produit_forfait_info.id_instance) {
            this.getOffres(this.produit_forfait_info.id_instance);
            this.getPaves(this.produit_forfait_info.id_instance);
        } else {
            this.isLoadingOffres = false;
        }
        if (this.produit_forfait_info.id_forfait) {
            this.getForfait(this.produit_forfait_info.id_forfait);
        } else {
            this.isLoadingForfait = false;
        }
        if (this.produit_forfait_info.url_instance) {
            this.url_instance = this.produit_forfait_info.url_instance;
        }
        this.setTags();
        this.isLoadingPrepaInfo = false;
    }

    ngOnDestroy() {
        if (this.produit_forfait_info.couleur_background && isPlatformBrowser(this.platformId)) {
            if (document.getElementById('instance-content')) {
                document.getElementById('instance-content').style.backgroundColor = '#fafafd';
            }
            if (document.getElementById('footer')) {
                document.getElementById('footer').style.backgroundColor = '#fafafd';
            }
        }
    }

    getPrepa(id_produit_forfait) {
        this.produitService.getPrepaById(id_produit_forfait).subscribe(
            (res: ProduitForfaitInfo) => {
                this.produit_forfait_info = res;
                this.handlePrepaInfoRecover();
                if (this.produit_forfait_info.couleur_background && isPlatformBrowser(this.platformId)) {
                    document.getElementById('instance-content').style.backgroundColor = this.produit_forfait_info.couleur_background;
                    document.getElementById('footer').style.backgroundColor = this.produit_forfait_info.couleur_background;
                }
            },
            (err) => {
                console.log(err);
                this.isLoadingPrepaInfo = false;
                this.isLoadingCenter = false;
                this.isLoadingOffres = false;
                this.isLoadingForfait = false;
            }
        );
    }

    getPaves(id_instance: number): void {
        this.paveService.get(id_instance).subscribe(res => {
            this.paves = res;
          });
    }

    getOffres(id_instance: number): void {
        this.offreEmploiService.getAllByIdInstance(id_instance).subscribe(
            (res: OffreEmploi[]) => {
                this.offres_emploi = res;
                this.isLoadingOffres = false;
            },
            (err) => {
                console.log(err);
                this.isLoadingOffres = false;
            }
        );
    }

    getForfait(id_forfait): void {
        this.produitService.getForfait(id_forfait.toString()).subscribe(
            (res: Forfait) => {
                this.forfait = res;
                if (this.forfait.prof) {
                    this.prof = this.forfait.prof;
                    this.isLoadingProf = false;
                } else {
                    this.isLoadingProf = false;
                }
                if (this.forfait && this.forfait.cours) {
                    this.sortCourseColumns();
                }
                this.isLoadingForfait = false;
            },
            (err) => {
                console.log(err);
                this.isLoadingForfait = false;
                this.isLoadingProf = false;
            }
        );
    }

    getCentresByIds(centresIds: []): void {
        this.centreService.getCentresByIds(centresIds).subscribe(
            (res: Centre[]) => {
                this.centres = res;
                this.nombre_de_centres = res.length;
                this.isLoadingCenter = false;
            },
            (err) => {
                console.log(err);
                this.isLoadingCenter = false;
            }
        );
    }

    sortCourseColumns() {
        let total_length = 0;
        let nb_cours = 0;
        this.forfait.cours.forEach(cours => {
            total_length = total_length + cours.commentaire.length;
            nb_cours++;
        });
        if (nb_cours === 1) {
            this.course_column_1.push(this.forfait.cours[0]);
        } else if (nb_cours === 2) {
            this.course_column_1.push(this.forfait.cours[0]);
            this.course_column_2.push(this.forfait.cours[1]);
        } else if (nb_cours > 2) {
            const mid_length = Math.trunc(total_length / 2);
            let current_length = 0;
            this.forfait.cours.forEach(cours => {
                current_length = current_length + cours.commentaire.length;
                if (current_length < mid_length + 200) {
                    this.course_column_1.push(cours);
                } else {
                    this.course_column_2.push(cours);
                }
            });
        }
    }

    highlithPriceOnHover(id: string) {
        if (isPlatformBrowser(this.platformId)) {
            document.getElementById(id).style.backgroundColor = '#000000';
            document.getElementById(id).style.color = '#ffffff';
        }
    }

    unhighlithPriceOnLeave(id: string) {
        if (isPlatformBrowser(this.platformId)) {
            if (this.forfait && this.forfait.couleurs) {
                document.getElementById(id).style.backgroundColor = '';
                document.getElementById(id).style.color = this.forfait.couleurs.couleur_texte_ligne;
            } else {
                // default colors
                document.getElementById(id).style.backgroundColor = '#CED3E7';
                document.getElementById(id).style.color = '#000000';
            }
        }
    }

    initColors() {
        if (this.forfait && this.forfait.couleurs) {
            this.setColors('.entete', this.forfait.couleurs.couleur_fond_entete, this.forfait.couleurs.couleur_texte_entete);
            this.setColors('.entete-reverse', this.forfait.couleurs.couleur_texte_entete, this.forfait.couleurs.couleur_fond_entete);
            this.setColors('.ligne', this.forfait.couleurs.couleur_fond_ligne, this.forfait.couleurs.couleur_texte_ligne);
            this.setColors('.text-color', 'transparent', this.forfait.couleurs.couleur_fond_entete);
            this.isLoadingForfait = false;
        } else {
            // default colors
            this.setColors('.entete', '#4F71BE', '#ffffff');
            this.setColors('.entete-reverse', '#ffffff', '#4F71BE');
            this.setColors('.ligne', '#CED3E7', '#000000');
            this.setColors('.text-color', 'transparent', '#4F71BE');
            this.isLoadingForfait = false;
        }
        if (this.produit_forfait_info && this.produit_forfait_info.couleur_texte) {
          this.setColors('.custom-color', 'transparent', this.produit_forfait_info.couleur_texte);
        }
    }

    setColors(ClassName, backgroundColor, textColor) {
        if (isPlatformBrowser(this.platformId)) {
            const elements = document.querySelectorAll(ClassName);
            const array = Array.from(elements);
            array.forEach(element => element.style.backgroundColor = backgroundColor);
            array.forEach(element => element.style.color = textColor);
        }
    }

    setBandeau() {
        if (isPlatformBrowser(this.platformId)) {
            const element = <HTMLDivElement> document.querySelector('.cover-photo');
            if (element) {
                if (this.produit_forfait_info && this.produit_forfait_info.bandeau) {
                    element.style.backgroundImage = 'url(\'https://www.apprentissage-montpellier.education/img/bandeaux/' + this.produit_forfait_info.bandeau + '\')';
                } else {
                    element.style.backgroundImage = 'url(\'https://www.apprentissage-montpellier.education/img/bandeaux/bandeau_hp.jpg\')';
                }
            }
        }
    }

}
